import {Observable} from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigService } from "./config.service";
import {RecommendationTypes} from "../models/recommendation/recommendation-types";

@Injectable()
export class RecommendationService {
    constructor(private http: HttpClient, private configService: ConfigService) {}

    dismiss(recommendationType: RecommendationTypes, organisationReference: string, propertyReference: string, roomReference: string, tenancyGuid: string): Observable<void> {
        let params = new HttpParams();
        if (organisationReference) params = params.set('organisationReference', organisationReference);
        if (propertyReference) params = params.set('propertyReference', propertyReference);
        if (roomReference) params = params.set('roomReference', roomReference);
        if (tenancyGuid) params = params.set('tenancyGuid', tenancyGuid);

        return this.http.post<void>(`${this.configService.baseUrl}/recommendation/type/${recommendationType}/dismiss`, null, {params});
    }

    snooze(recommendationType: RecommendationTypes, organisationReference: string, propertyReference: string, roomReference: string, tenancyGuid: string): Observable<void> {
        let params = new HttpParams();
        if (organisationReference) params = params.set('organisationReference', organisationReference);
        if (propertyReference) params = params.set('propertyReference', propertyReference);
        if (roomReference) params = params.set('roomReference', roomReference);
        if (tenancyGuid) params = params.set('tenancyGuid', tenancyGuid);

        return this.http.post<void>(`${this.configService.baseUrl}/recommendation/type/${recommendationType}/snooze`, null, {params});
    }

    getRecommendation(recommendationType: RecommendationTypes, organisationReference: string, propertyReference: string, roomReference: string, tenancyGuid: string): Observable<boolean> {
        let params = new HttpParams();
        if (organisationReference) params = params.set('organisationReference', organisationReference);
        if (propertyReference) params = params.set('propertyReference', propertyReference);
        if (roomReference) params = params.set('roomReference', roomReference);
        if (tenancyGuid) params = params.set('tenancyGuid', tenancyGuid);

        return this.http.get<boolean>(`${this.configService.baseUrl}/recommendation/type/${recommendationType}`, {params});
    }
}
